import {state} from "./state";
import {drawPaths} from "./paths";
import {enableMarkersDrag, disableMarkersDrag, setChallengeClickEnabled} from "./markers";
import {toggleGallery} from "./ui.js";
import {enableAnimatedImagesDrag, disableAnimatedImagesDrag} from "./animated-images";

export function enableEditMode() {
    state.editMode = true;
    drawPaths();
    enableMarkersDrag();
    enableAnimatedImagesDrag();
    toggleGallery(true);
    setChallengeClickEnabled(false);
}

export function disableEditMode() {
    state.editMode = false;
    drawPaths();
    disableMarkersDrag();
    disableAnimatedImagesDrag();
    toggleGallery(false);
    setChallengeClickEnabled(true);
}
